// extracted by mini-css-extract-plugin
export var customh1 = "blocks-module--customh1--d39d2";
export var marginBlock = "blocks-module--marginBlock--7889c";
export var phoneLink = "blocks-module--phoneLink--53edd";